export const ACCESS_TOKEN_PREFIX = 'Bearer';
export const ACCESS_TOKEN_STORAGE_KEY = 'accessToken';
export const USER_STORAGE_KEY = 'user';
